<h1 mat-dialog-title>{{ 'uploadDialog.title' | translate }}</h1>
<button (click)="close()" mat-icon-button test-id="dialog-close-button" class="mat-dialog-close-button">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <upload-dropzone (afterFilesAdded)="uploadFileList($event)"></upload-dropzone>
  <ul test-id="pending-uploads" class="upload-status-list">
    <li *ngFor="let status of uploadStatus" class="file-status">
      <div class="file-info">
        <div>
          <span class="file-name">{{ status.file.name }}</span>
          <span class="file-size"><strong>{{ status.size[0] }}</strong> {{ status.size[1] }}</span>
        </div>
        <div *ngIf="status.error" class="file-error">{{ status.error }}</div>
      </div>
      <div *ngIf="status.progress < 100 && !status.error" class="file-progress">
        <mat-progress-bar mode="determinate" [value]="status.progress"></mat-progress-bar>
      </div>
      <div *ngIf="status.progress === 100" class="file-action">
        <span class="text-success" test-id="acquisition-upload-complete">{{ 'common.labels.success' | translate }}</span>
      </div>
      <div *ngIf="status.error" class="file-action">
        <button mat-stroked-button test-id="file-upload-retry" (click)="retryFile(status)">{{ (status.duplicate ? 'common.actions.replace' : 'common.actions.retry') | translate }}</button>
      </div>
    </li>
  </ul>
</div>
<div mat-dialog-actions align="end">
  <button (click)="close()" mat-flat-button color="primary" test-id="upload-dialog-close">{{ 'common.actions.close' | translate }}</button>
</div>
